import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2cfde4d0")
const _hoisted_1 = {
  key: 0,
  class: "justify-center d-flex dialog-image"
}
const _hoisted_2 = { class: "rounded-lg pa-2" }
const _hoisted_3 = { class: "mb-4 text-h6 grey lighten-2 font-weight-black" }
const _hoisted_4 = {
  key: 0,
  class: "error pa-2"
}
const _hoisted_5 = { class: "mt-8 d-flex justify-space-between align-end" }
_popScopeId()

import { withDefaults, ref } from 'vue'
import Action from './enums/DialogAction'

interface IProps {
  title?: string
  imageSrc?: string
  errors?: string
  action?: string
  width?: number
  submit?: () => boolean | Promise<boolean>
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: { type: String, required: false, default: '' },
    imageSrc: { type: String, required: false, default: '' },
    errors: { type: String, required: false, default: '' },
    action: { type: String, required: false, default: Action.ACTIVATE },
    width: { type: Number, required: false, default: 400 },
    submit: { type: Function, required: false, default: () => true }
  },
  setup(__props: any) {

const props = __props as { title: string, imageSrc: string, errors: string, action: string, width: number, submit: () => boolean | Promise<boolean> }


const dialog = ref(false)

const handleCancel = (): void => {
  dialog.value = false
}

const handleSubmit = async (): Promise<void> => {
  const isValid = await props.submit()
  if (isValid && !props.errors) {
    dialog.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_lottie_player = _resolveComponent("lottie-player")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (dialog.value = $event))
  }, {
    activator: _withCtx((data) => [
      _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps(data)))
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "dialog-content pa-4",
        style: _normalizeStyle(`width: ${__props.width}px`)
      }, {
        default: _withCtx(() => [
          (props.imageSrc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_lottie_player, {
                  src: props.imageSrc,
                  background: "transparent",
                  speed: "0.5",
                  class: "lottie-player",
                  loop: "",
                  autoplay: ""
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(props.title), 1),
            _createElementVNode("div", null, [
              _renderSlot(_ctx.$slots, "content")
            ]),
            (props.errors)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("p", null, _toDisplayString(props.errors), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_btn, {
                class: "mr-2 text-disabledText dialog-actions",
                color: "disabled",
                text: "",
                onClick: handleCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('actions.cancel')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                class: "dialog-actions",
                text: "",
                onClick: handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`dialog.actions.${props.action}`.toLowerCase())), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 3
      }, 8, ["style"])
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})